
<div *ngIf="config?.paymentOptions?.options?.TOPWALLET" class="list-wrapper">
  <div class="info">Please select your wallet account</div>
  <div class="top-list">
    <button type="button" *ngFor="let item of config?.paymentOptions?.options?.TOPWALLET | keyvalue" class="list-icons" (click)="selectWallet(item)" mat-stroked-button
      [ngClass]="{'active': item?.key==selectedWallet?.key}">
      <div class="logo" [class]="item?.key"></div>
    </button>
  </div>
</div>

<div *ngIf="config?.paymentOptions?.options?.TOPRECURRINGWALLET" class="payment-sip-wallet">
  <img loading="lazy" data-src="/assets/images/portfolio/paytm-pledge-v2.png" alt="Paytm Pledge image">
</div>

